<template>
  <div>
    <transition name="fade">
    <ul>
      <li v-for="(el, key, i) in attributes.value" :key="i"
        :class="{'active' : current == key}"
        @click="clickHandler(key.toLowerCase())"
      > {{ el }}</li>
    </ul>
    </transition>
  </div>
</template>
<script>
export default {
  props: ['attributes'],
  data () {
    return {
      current: null
    }
  },
  methods: {
    clickHandler (el) {
      this.current = el
      let element = document.getElementById(el)
      element.scrollIntoView()
    },
    handleScroll () {
      let sections = document.querySelectorAll('section.quarter span.nav')
      let fromTop = window.scrollY
      sections.forEach(el => {
        if (el.offsetTop - fromTop > 0 && el.offsetTop - fromTop < 150) {
          this.current = el.id
        }
      })
    }
  },
  mounted () {
    window.addEventListener('scroll', this.handleScroll)
  }
}
</script>
